<template>
  <div class="container">
    <div v-if="exam_info.exam_date">
      <!-- <Breadcrumb :customBreadcrumbList="[{ name: 'ToeflTestResults' }]">
        <template slot="lastPage">
          {{ exam_info.tpo }} {{ exam_info.exam_title }}
        </template>
      </Breadcrumb> -->
      <div class="row sat">
        <div class="col-md-5 col-sm-12 sat_left">
          <p>IELTS</p>
        </div>
        <div class="col-md-7 col-sm-12 sat_right row">
          <div class="col-sm-7">
            <ul>
              <li>
                Name:
                <span><a href="">Student</a></span>
              </li>
              <li v-if="topic.length !== 1">
                Test Name:
                <span> Test 5</span>
              </li>
              <li v-else>
                Test Name:
                <span> Test 5</span>
              </li>
              <li>
                Test Date:
                <span>{{ instant.formatGoogleTime(exam_date) }}</span>
              </li>
            </ul>
          </div>
          <div class="col-sm-5 img">
            <a href="/">
              <LogoText />
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6 user-scores">
          <score-card
            :user_score="user_score"
            :id="user_exam_id"
            :realTotal="6.5"
            :scoreDate="formateDateTime(exam_date)"
            :reading="true"
            :listening="true"
            :speaking="true"
            :writing="true"
          ></score-card>
        </div>
        <div class="col-sm-12 col-md-6">
          <best-score-card
            :user_score="user_score"
            :realTotal="6.5"
          ></best-score-card>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="text-center">
        <el-alert
          style="width:200px;margin:30px auto"
          title="Loading..."
          type="success"
          :closable="false"
          effect="dark"
        >
        </el-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { instant } from "@ivy-way/material";
import "./style/reportcard.css";
import Breadcrumb from "@/components/Breadcrumb";
import IELTS from "@/apis/ielts.js";
import TOEFL from "@/apis/toefl";
import role from "@/mixins/role.js";
import _ from "lodash";
import ScoreCard from "./ScoreCard";
import BestScoreCard from "./BestScoreCard";
import LogoText from "@/components/LogoText";
import helpers from "@/mixins/helper.js";

export default {
  metaInfo() {
    return {
      title: "IELTS Test Result - " + this.CompanyName
    };
  },

  components: {
    // Breadcrumb,
    ScoreCard,
    BestScoreCard,
    LogoText
  },

  mixins: [role, helpers],

  props: [],
  data() {
    return {
      topic: [],
      exam_info: { student: { first_name: "", last_name: "" } },
      pointPackages: [],
      updateAnswers: [],
      exam_date: "2022-06-05 11:05",
      user_score: {
        reading_raw: 0,
        reading_score: 6,
        reading_status: null,
        listening_raw: 8,
        listening_score: 8.5,
        listening_status: null,
        speaking_score: 5.5,
        speaking_status: null,
        writing_score: 5.5,
        writing_status: null,
        reading_question_count: 0,
        listening_question_count: 40,
        max_reading: {
          max_reading_score: 6,
          id: 323992,
          user_exam_id: 323992,
          created_at: "2022-06-05"
        },
        max_listening: {
          max_listening_score: 8.5,
          id: 323992,
          user_exam_id: 323992,
          created_at: "2022-06-05"
        },
        max_speaking: {
          max_speaking_score: 5.5,
          id: 323992,
          user_exam_id: 323992,
          created_at: "2022-06-05"
        },
        max_writing: {
          max_writing_score: 5.5,
          id: 323992,
          user_exam_id: 323992,
          created_at: "2022-06-05"
        }
      }
    };
  },
  computed: {
    instant() {
      return instant;
    },
    isAdmin() {
      let isAdmin = this.isRoleAdmin();
      return isAdmin;
    },
    user_exam_id() {
      return this.$route.query.id;
    },
    reading_list() {
      return _.groupBy(
        _.filter(this.topic, ["skill_name", "reading"]),
        "passage"
      );
    },
    listening_list() {
      return _.groupBy(
        _.filter(this.topic, ["skill_name", "listening"]),
        "passage"
      );
    },
    speaking_list() {
      let speaking_list = _.filter(this.topic, ["skill_name", "speaking"]);
      speaking_list.forEach(element => {
        this.$set(element, "canPlay", true);
        this.$set(element, "width", 0);
        this.$set(element, "progress", 0);
        this.$set(element, "time", 60);
        this.$set(element, "speed", 1);
      });
      return speaking_list;
    },
    writing_list() {
      let writing_list = _.filter(this.topic, ["skill_name", "writing"]);
      return writing_list;
    }
  },
  watch: {},

  mounted() {
    this.getTranscript();
  },

  methods: {
    async sendEmail() {
      const res = await TOEFL.sendEmail(this.user_exam_id);
      this.$message({
        message: "Success!",
        type: "success"
      });
    },
    getArr(arr) {
      arr.forEach(val => {
        let newVal = {
          id: val.user_exam_answer_id,
          score: val.score,
          suggest: val.suggest
        };
        this.updateAnswers.push(newVal);
      });
    },
    async saveTranscript() {
      this.updateAnswers = [];
      this.getArr(this.speaking_list);
      this.getArr(this.writing_list);
      await TOEFL.updateTranscript(this.user_exam_id, {
        user_exam_answers: this.updateAnswers
      });
      this.$message({
        message: "Success!",
        type: "success"
      });
      this.getTranscript();
    },
    getAlert() {
      this.$refs.lock.getAlert();
    },
    async getTranscript() {
      const res = await IELTS.getTranscript(this.user_exam_id);
      // this.user_score = res.user_score;
      this.topic = res.topic;
      this.exam_info = res.exam_info;
    },
    isEmpty(object) {
      return _.isEmpty(object);
    },
    getResolve(question_id) {
      const { href } = this.$router.resolve({
        name: "IeltsResolve",
        query: {
          user_exam_id: this.user_exam_id,
          question_id: question_id
        }
      });
      window.open(href, "_blank");
    },
    async saveScore(user_exam_answer_id, score) {
      await TOEFL.gradeScore(user_exam_answer_id, {
        score: score
      });
      this.getTranscript();
    }
  }
};
</script>

<style scoped>
hr.section {
  border: 0;
  border-bottom: 3px solid var(--themeColor);
  margin: 20px 0;
}
.reportcard {
  padding: 20px;
}
.sat_left > p:first-child {
  font-size: 120px;
  font-weight: 700;
  color: var(--themeColor);
  line-height: 120px;
  margin-bottom: 0px;
}
.tip {
  padding: 8px 16px;
  background-color: #ff770c40;
  border-radius: 4px;
  border-left: 5px solid var(--themeColor);
  margin: 0 0 20px 0;
}
.tip .text {
  font-size: 14px;
  font-weight: 500;
}
@media screen and (max-width: 736px) {
  .sat_left > p:first-child {
    font-size: 60px;
    line-height: 60px;
    /* text-align: center; */
  }
  .sat_right {
    padding: 0 0 0 0;
    border: none;
  }
  .sat_right .img {
    display: none;
  }
  .sat_right ul li {
    font-size: 16px;
  }
  .user-scores {
    margin-bottom: 20px;
  }
}
</style>
